import { BaseEntity } from '../../../models';
import { UsuarioPopulavel } from '../popula';
import { Usuario } from '../usuario';
import { UnidadeNegocio } from '../../unidade-negocio/unidade-negocio';
import { UnidadeNegocioPopulavel } from '../../unidade-negocio/popula/unidade-negocio-populavel';

export class UsuarioUnidadeNegocio implements BaseEntity, UsuarioPopulavel, UnidadeNegocioPopulavel {
    readonly id: number;
    idUsuario: number;
    usuario: Usuario;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
}
